<template>
  <el-dialog
    title="混剪设置"
    :visible.sync="dialogVisible"
    width="650px"
    :close-on-click-modal="false"
    custom-class="cut-setting-dialog"
    @open="onModalOpen"
    append-to-body
  >
    <el-form ref="formRef" :model="formData" :rules="configFormRules" label-position="top" class="cut-form ghost-button-styles">
      <!-- 视频命名 -->
      <el-form-item class="form-section" prop="taskName">
        <div class="section-header">
          <i class="el-icon-video-camera section-icon"></i>
          <span class="section-title">视频命名</span>
        </div>
        <div class="naming-input-row">
          <el-input v-model="formData.taskName.imageName" placeholder="前缀" class="naming-input"></el-input>
          <span class="separator">&</span>
          <el-input v-model="formData.taskName.imageNameStartNum" placeholder="起始编号" class="naming-input"></el-input>
          <span class="suffix-text">-片段A{id}片段B{id}-横版/竖版</span>
        </div>
        <div class="section-tips">说明示例：gh234-234_544_433_356-横版/竖版，素材ID之间用下划线连接</div>
      </el-form-item>

      <el-divider></el-divider>

      <!-- 视频比例 -->
      <div class="form-section">
        <div class="section-header mb-12">
          <span class="section-title">视频比例</span>
        </div>

        <el-checkbox-group v-model="formData.videoRatio" prop="videoRatio">
          <el-checkbox-button ghost :label="1">16:9</el-checkbox-button>
          <el-checkbox-button ghost :label="2">9:16</el-checkbox-button>
          <!-- <el-checkbox-button ghost label="3"> </el-checkbox-button>
          <el-checkbox-button ghost label="4"> </el-checkbox-button> -->
        </el-checkbox-group>
      </div>

      <el-divider></el-divider>

      <!-- 背景包边 -->
      <div class="form-section flex-between">
        <div class="section-header">
          <i class="el-icon-picture-outline section-icon"></i>
          <span class="section-title">背景包边</span>
        </div>
        <el-switch v-model="formData.backgroundImgSwitch" :active-value="1" :inactive-value="0"></el-switch>
      </div>
      <div v-if="formData.backgroundImgSwitch" class="watermark-settings">
        <el-form-item label="背景图片" prop="background">
          <div v-if="formData.background.imgs.length">
            <span> {{ formData.background.imgs.map((item) => item.name).join('、') }}</span>
            <span>&ensp;</span>
            <el-button type="text" @click="onImageSelect(selectPositionLabel.backgroundImg)">选择更多</el-button>
            <el-button type="text" @click="formData.background.imgs = []">清空</el-button>
          </div>
          <div v-else class="watermark-uploader" @click="onImageSelect(selectPositionLabel.backgroundImg)">
            <div class="uploader-content">
              <i class="el-icon-upload2 uploader-icon"></i>
              <div class="uploader-text">选择图片</div>
            </div>
          </div>
        </el-form-item>
      </div>

      <el-divider></el-divider>

      <!-- 警示语 -->
      <div class="form-section">
        <div class="flex-between mb-16">
          <div class="section-header">
            <i class="el-icon-warning-outline section-icon"></i>
            <span class="section-title">警示语</span>
          </div>
          <el-switch v-model="formData.warningsSwitch" :active-value="1" :inactive-value="0"></el-switch>
        </div>

        <div v-if="formData.warningsSwitch" class="warning-settings">
          <el-form-item label="警示语内容" porp="warnings.warningsContent">
            <el-input v-model="formData.warnings.warningsContent" type="textarea" :rows="2" placeholder="请输入警示内容"></el-input>
          </el-form-item>

          <el-form-item label="字体">
            <el-select v-model="formData.warnings.warningsFontName" placeholder="请选择" style="width: 100%">
              <el-option v-for="font in FONT_NAMES" :key="font" :label="font" :value="font"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="字号" prop="warnings.warningsFontSize">
            <SizeRangeInput
              :value="{
                previewValue: formData.warnings.warningsFontSizeH,
                nextValue: formData.warnings.warningsFontSizeV
              }"
              @input="onWarningFontSizeChange"
            ></SizeRangeInput>
          </el-form-item>

          <el-form-item label="字体颜色">
            <div class="color-input-row">
              <el-color-picker v-model="formData.warnings.warningsFontColor" size="small"></el-color-picker>
              <el-input v-model="formData.warnings.warningsFontColor" class="ml-12"></el-input>
            </div>
          </el-form-item>

          <el-form-item label="距底部距离" prop="warnings.warningsBottom">
            <SizeRangeInput
              :value="{
                previewValue: formData.warnings.warningsBottomH,
                nextValue: formData.warnings.warningsBottomV
              }"
              @input="onWarningBottomGapChange"
            ></SizeRangeInput>
          </el-form-item>

          <el-form-item label="透明度" class="mb-0">
            <div class="opacity-row">
              <el-slider v-model="formData.warnings.warningsDiaphaneity" class="flex-1"></el-slider>
              <span class="opacity-value">{{ formData.warnings.warningsDiaphaneity }}%</span>
            </div>
          </el-form-item>
        </div>
      </div>

      <el-divider></el-divider>

      <!-- 水印 -->
      <div class="form-section">
        <div class="flex-between mb-16">
          <div class="section-header">
            <i class="el-icon-picture-outline-round section-icon"></i>
            <span class="section-title">水印</span>
          </div>
          <el-switch v-model="formData.watermarkSwitch" :active-value="1" :inactive-value="0"></el-switch>
        </div>

        <div v-if="formData.watermarkSwitch" class="watermark-settings">
          <el-form-item label="水印图片" prop="watermark">
            <div @click="onImageSelect(selectPositionLabel.watermarkImg)">
              <img v-if="formData.watermark.img" style="height: 124px" :src="formData.watermark.img.url" alt="" />
              <div v-else class="watermark-uploader">
                <div class="uploader-content">
                  <i class="el-icon-upload2 uploader-icon"></i>
                  <div class="uploader-text">选择图片</div>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="透明度" class="mb-0">
            <div class="opacity-row">
              <el-slider v-model="formData.watermark.watermarkDiaphaneity" class="flex-1"></el-slider>
              <span class="opacity-value">{{ formData.watermark.watermarkDiaphaneity }}%</span>
            </div>
          </el-form-item>

          <el-form-item label="运动方式" class="mt-16">
            <el-radio-group v-model="formData.watermark.watermarkSportModel" class="motion-radio-group">
              <el-radio-button ghost :label="1" class="motion-btn">随机滚动</el-radio-button>
              <!-- <el-radio-button ghost :label="2" class="motion-btn">静止</el-radio-button> -->
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <AssetsSelector
      v-bind="{ ...selectorProps, visible: showSelectorModal }"
      :before-submit="selectorProps.selectPosition === selectPositionLabel.backgroundImg ? onSelectorBeforeSubmit : null"
      @close="onSelectorClose"
      @confirm="onSelectorConfirm"
    >
      <template v-slot:assetType="{ getData }">
        <el-radio
          v-model="selectorProps.assetType"
          :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.STICKER]"
          @change="getData"
          :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.STICKER]"
          >贴纸</el-radio
        >
      </template>

      <template v-slot:sizes="{ getData }">
        <!-- 多选尺寸 -->
        <el-select
          v-if="isSelectingBgImg"
          style="width: 160px"
          popper-class="creative-selector-el-select-popper"
          :popper-append-to-body="false"
          v-model="selectorProps.form.sizes"
          clearable
          multiple
          collapse-tags
          @change="getData"
        >
          <el-option v-for="item in materialSizes" :key="item.label" :label="item.label" :value="item.label"> </el-option>
        </el-select>

        <!-- 单选尺寸 -->
        <el-select
          v-else
          style="width: 160px"
          popper-class="creative-selector-el-select-popper"
          :popper-append-to-body="false"
          v-model="selectorProps.form.size"
          clearable
          @change="getData"
        >
          <el-option v-for="item in materialSizes" :key="item.label" :label="item.label" :value="item.label"> </el-option>
        </el-select>
      </template>
    </AssetsSelector>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onConfigConfirm">确认并开始混剪</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { computed, ref, watch, onMounted } from 'vue'
import Cookies from 'js-cookie'
import { Message } from 'view-design'
import { getLocal, setLocal } from '@/common/js/api.js'
import AssetsSelector from '@/components/material-selector/index.js'
import SizeRangeInput from '@/views/creatives/components/config-form/size-range.vue'
import { FONT_NAMES } from '@/views/creatives/const'
import { creativePlanTaskExec } from '@/api/creative.model.js'
import getConfigFormRules from '@/views/creatives/components/config-form/form-rules.js'
import { useMaterialSelector, selectPositionLabel, materialSizes, getForm } from '../../../hooks/editor.js'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
const opId = Cookies.get('ch_op_id')
// eslint-disable-next-line
const props = defineProps({
  value: {
    type: Boolean
  },
  taskInfo: {
    type: Object
  }
})
// eslint-disable-next-line
const emits = defineEmits(['input', 'confirm'])
const dialogVisible = computed({
  get: () => props.value,
  set(val) {
    emits('input', val)
  }
})
const formRef = ref(null)
const formData = ref({ ...getForm() })

const submitLoading = ref(false)

const configFormRules = getConfigFormRules.call(formData)

// 缓存相关配置
const CACHE_KEY_PREFIX = 'formConfig_'
const MAX_CACHE_SIZE = 1024 * 1024 // 1MB

// 读取缓存
const loadConfigFromCache = () => {
  if (!opId) return
  try {
    const key = `${CACHE_KEY_PREFIX}${opId}`
    const cached = getLocal(key)
    if (cached && typeof cached === 'object') {
      // 合并缓存配置，确保结构完整
      // 使用默认表单数据作为底板，覆盖缓存数据
      formData.value = { ...getForm(), ...cached }
    }
  } catch (e) {
    console.error('Failed to load form config from cache:', e)
  }
}

// 写入缓存
const saveConfigToCache = () => {
  if (!opId) return
  try {
    const key = `${CACHE_KEY_PREFIX}${opId}`
    // 检查数据大小
    const str = JSON.stringify(formData.value)
    if (str.length > MAX_CACHE_SIZE) {
      console.warn('Form config exceeds 1MB limit, skipping cache update')
      return
    }
    setLocal(key, formData.value)
  } catch (e) {
    console.error('Failed to save form config to cache:', e)
  }
}
const onModalOpen = () => {
  loadConfigFromCache()
}

// 是否在选择包边图片
const { showSelectorModal, selectorProps, onImageSelect, onMetaMaterialSelect, onSelectorClose } = useMaterialSelector()
const isSelectingBgImg = computed(() => selectorProps.value.selectPosition === selectPositionLabel.backgroundImg)
const seletedMaterialRadioDiasbled = computed(() => {
  const { selectPosition } = selectorProps.value

  const states = {
    [MATERIAL_TYPE.STICKER]: true
  }

  if (selectPosition === selectPositionLabel.watermarkImg || selectPosition === selectPositionLabel.backgroundImg) {
    states[MATERIAL_TYPE.STICKER] = false
  }

  return states
})

const onSelectorBeforeSubmit = (selectedRows, callbacks) => {
  for (let i = 0; i < selectedRows.length; i++) {
    const row = selectedRows[i]
    const { width, height } = row
    const shape = `${width}*${height}`
    const sizes = materialSizes.map((s) => s.label)
    if (!sizes.includes(shape)) {
      callbacks.fail('包边尺寸限制720*1280px或1280*720px')
      return
    }
  }
  callbacks.done()
}

function onWarningFontSizeChange(val) {
  formData.value.warnings.warningsFontSizeH = val.previewValue
  formData.value.warnings.warningsFontSizeV = val.nextValue
}
function onWarningBottomGapChange(val) {
  formData.value.warnings.warningsBottomH = val.previewValue
  formData.value.warnings.warningsBottomV = val.nextValue
}

function onSelectorConfirm(assets) {
  console.log('assets output: ', assets)
  const { selectPosition } = selectorProps.value
  if (selectPosition === selectPositionLabel.backgroundImg) {
    formData.value.background.imgs = assets
  } else if (selectPosition === selectPositionLabel.watermarkImg) {
    formData.value.watermark.img = assets[0]
  }

  formRef.value.clearValidate()
}

function onConfigConfirm() {
  formRef.value.validate((valid) => {
    if (valid) {
      const { taskName, backgroundImgSwitch, background, warningsSwitch, warnings, watermarkSwitch, watermark, videoRatio } = formData.value
      const params = {
        ...taskName,
        videoRatio,
        backgroundImgSwitch,
        warningsSwitch,
        watermarkSwitch
      }

      if (backgroundImgSwitch) {
        params.backgroundImgIds = background.imgs.map((img) => img.id)
      }
      if (warningsSwitch) {
        Object.assign(params, warnings)
      }

      if (watermarkSwitch) {
        const { img, ...rests } = watermark
        Object.assign(params, { ...rests, watermarkImgId: img.id })
      }
      submitLoading.value = true
      creativePlanTaskExec({ ...params, ...props.taskInfo })
        .then((data) => {
          if (data) {
            Message.success('任务创建成功')
            dialogVisible.value = false
            emits('confirm')
            saveConfigToCache()
            formData.value = getForm()
          }
        })
        .finally(() => {
          submitLoading.value = false
        })
    } else {
      const el = formRef.value.$el?.querySelector('.el-form-item__error')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  })
}
</script>

<style scoped lang="scss">
.cut-form {
  height: 620px;
  padding: 10px 20px;
  overflow: auto;
  .form-section {
    margin: 4px 0;
  }

  .section-header {
    display: flex;
    align-items: center;
    gap: 8px;

    .section-icon {
      font-size: 18px;
      color: #409eff;
    }

    .section-title {
      font-weight: 600;
      color: #303133;
      font-size: 14px;
    }
  }

  .naming-input-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;
    margin-bottom: 8px;

    .naming-input {
      width: 140px;
    }

    .separator {
      color: #606266;
      font-weight: bold;
    }

    .suffix-text {
      color: #606266;
      font-size: 13px;
    }
  }

  .section-tips {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
  }

  .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .subtitle-settings {
    margin-top: 16px;
    padding-left: 4px;
  }

  .color-input-row {
    display: flex;
    align-items: center;

    .ml-12 {
      margin-left: 12px;
    }
  }

  .opacity-row {
    display: flex;
    align-items: center;
    gap: 16px;

    .flex-1 {
      flex: 1;
    }

    .opacity-value {
      width: 40px;
      text-align: right;
      color: #606266;
    }
  }

  .mb-12 {
    margin-bottom: 12px;
  }
  .mb-16 {
    margin-bottom: 16px;
  }
  .mb-0 {
    margin-bottom: 0;
  }

  .mt-16 {
    margin-top: 16px;
  }

  .watermark-settings {
    padding-left: 4px;

    .watermark-uploader {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fbfdff;
      transition: border-color 0.3s;

      &:hover {
        border-color: #409eff;
      }

      .uploader-content {
        text-align: center;
        color: #8c939d;
      }

      .uploader-icon {
        font-size: 24px;
        margin-bottom: 8px;
      }

      .uploader-text {
        font-size: 12px;
      }
    }

    .motion-radio-group {
      display: flex;
      width: 100%;
      gap: 12px;

      .motion-btn {
        flex: 1;

        ::v-deep .el-radio-button__inner {
          width: 100%;
          border-radius: 4px;
          border-left: 1px solid #dcdfe6;
          padding: 10px 0;
        }

        &.is-active ::v-deep .el-radio-button__inner {
          border-color: #409eff;
          box-shadow: -1px 0 0 0 #409eff;
        }
      }
    }
  }

  .el-divider--horizontal {
    margin: 20px 0;
  }
}
</style>
